import React from 'react';
import type {SxProps} from '@mui/material';
import type {ThesaurusId} from 'schemaDefinition/types';
import type {SearchMatch} from 'services/thesaurus/types';
import {ColorPalette} from 'theme';
import {Layout} from 'components';
import {ThesaurusNodePath} from '../../editThesaurus/components';
import {useThesaurusContext} from '../hooks';
import {SearchMatchAction} from './SearchMatchAction';

type Props = {
  thesaurusId: ThesaurusId;
  match: SearchMatch;
};

const sxNodeButton: SxProps = {
  borderRadius: 1,
  background: ColorPalette.lightBeige,
  py: 1,
  pl: 1,
  pr: 2,
};

export const SearchResultMatch: React.FC<Props> = ({thesaurusId, match}) => {
  const {searchQuery, getDisplayCode, getNodeAction, addNodeId, removeNodeId} =
    useThesaurusContext(thesaurusId);

  const {ancestors, hasTitleMatch, hasSynonymMatch} = match;

  const showSynonymMatch = hasSynonymMatch && !hasTitleMatch;
  const icon = showSynonymMatch ? 'DoubleChevronRight' : undefined;

  const code = getDisplayCode(match.node);

  return (
    <Layout
      horizontal
      adjustCenter
      justifyContent={'space-between'}
      sx={sxNodeButton}>
      <ThesaurusNodePath
        node={match}
        code={code}
        prefixIcon={icon}
        searchQuery={searchQuery}
        pathSx={sxNodeButton}
        showCategory
      />
      {/* No edit action for category nodes */}
      {ancestors.length > 1 ? (
        <SearchMatchAction
          nodeId={match.node.id}
          action={getNodeAction(match.node.id)}
          addNodeId={addNodeId}
          removeNodeId={removeNodeId}
        />
      ) : null}
    </Layout>
  );
};
